<div id="circle-wrapper" class="d-flex justify-content-center my-4">
  <div class="results-circle d-flex flex-column justify-content-center align-items-center">
    @if (!errored) {
      <div>
        <div class="text-center h4 font-weight-bold">Maximum Affordable Loan Amount</div>
        <div class="text-center h1 text-primary">
          <span>{{ amount | currency: 'GBP':'symbol':'1.0-0' }}</span>
        </div>
        <div class="text-center h4 font-weight-bold">Monthly Payment Amount</div>
        <div class="text-center h1 text-primary">
          <span>{{ monthlyAmount | currency: 'GBP':'symbol':'1.0-0' }}</span>
        </div>
      </div>
    }
    @if (errored) {
      <span>Could not get result</span>
    }
  </div>
</div>
